































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RegrasDeCalculoStore from '@/components/RemuneracaoMedica/RegrasDeCalculo/Store/RegrasDeCalculoStore'
import EventBus from '@/plugins/EventBus'
import { onlyFloat } from '@/utils/common'
import moment from 'moment'

@Component
export default class ModalRegraGestaoIncluir extends Vue {
  menuInicioVigencia: boolean = false
  menuFimVigencia: boolean = false

  loadAddRegraCalculo: boolean = false
  get loadingAddRegraCalculo() { return this.loadAddRegraCalculo }
  set loadingAddRegraCalculo(value: boolean) { this.loadAddRegraCalculo = value }

  get getRegrasDeCalculoStore() { return getModule(RegrasDeCalculoStore, this.$store) }

  get showModal() { return this.getRegrasDeCalculoStore.modal.regraDeCalculoGestao }
  set showModal(value: boolean) { this.getRegrasDeCalculoStore.setModal({ name: 'regraDeCalculoGestao', value }) }

  get mode() { return this.getRegrasDeCalculoStore.modeModalRegraValoresFixos }

  get centroDeCusto() { return this.getRegrasDeCalculoStore.centroDeCusto }
  get transacaoFinanceira() { return this.getRegrasDeCalculoStore.transacaoFinanceira }
  get fontesPagadoras() { return this.getRegrasDeCalculoStore.fontesPagadoras }
  get profissionaisExecutantes() { return this.getRegrasDeCalculoStore.profissionaisExecutantes }
  get prestadores() { return this.getRegrasDeCalculoStore.prestadoresRepasse }
  get gruposRepasse() { return this.getRegrasDeCalculoStore.gruposRepasse }
  get subGruposRepasse() { return this.getRegrasDeCalculoStore.subGruposRepasse }
  get gestores() { return this.getRegrasDeCalculoStore.gestores }
  get localExecucaoById() { return this.getRegrasDeCalculoStore.localExecucaoById }

  get getMenuInicioVigencia() { return this.menuInicioVigencia }
  set getMenuInicioVigencia(value: boolean) { this.menuInicioVigencia = value }
  get getMenuFimVigencia() { return this.menuFimVigencia }
  set getMenuFimVigencia(value: boolean) { this.menuFimVigencia = value }

  formatDate(vigencia: any) {
    const date = new Date(vigencia)
    if (!Number.isNaN(date.getTime())) {
      const day = String(date.getUTCDate()).padStart(2, '0')
      const month = String(date.getUTCMonth() + 1).padStart(2, '0')
      const year = date.getUTCFullYear()
      return `${day}/${month}/${year}`
    }
    console.error('Data inválida:', vigencia)
    return ''
  }

  get formattedInicioVigencia() {
    const { vigenciaInicio } = this.getRegrasDeCalculoStore.regraGestaoItem
    if (vigenciaInicio) {
      return this.formatDate(vigenciaInicio)
    }
    return ''
  }

  get formattedFimVigencia() {
    const { vigenciaFim } = this.getRegrasDeCalculoStore.regraGestaoItem
    if (vigenciaFim) {
      return this.formatDate(vigenciaFim)
    }
    return ''
  }

  async addValorFixo() {
    this.loadingAddRegraCalculo = true
    const paginacaoAtual = this.getRegrasDeCalculoStore.paginacaoRegrasValorFixo
    const request = await this.getRegrasDeCalculoStore.addRegraGestao()
    if (!request.success) {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: `${request.message} ${String.fromCodePoint(0x1F615)}`,
        icon: 'warning',
        color: '#C62828',
      })
      this.loadingAddRegraCalculo = false
      return
    }
    EventBus.$emit('setSnackbar', {
      show: true,
      text: `Procedimento incluído com sucesso. ${String.fromCodePoint(0x1F642)}`,
      icon: 'done',
      color: '#2E7D32',
    })
    this.loadingAddRegraCalculo = false
    this.getRegrasDeCalculoStore.getRegrasGestao(paginacaoAtual)
    this.showModal = false
  }

  mounted() {
    this.getRegrasDeCalculoStore.getPrestadoresRepasse()
    this.getRegrasDeCalculoStore.getProfissionais()
    this.getRegrasDeCalculoStore.getCentroDeCusto()
    this.getRegrasDeCalculoStore.getGruposRepasse()
    this.getRegrasDeCalculoStore.getTransacaoFinanceiraFixo()
  }

  @Watch('getRegrasDeCalculoStore.regraGestaoItem.fontePagadoraFiltroId')
  onFontePagadoraFiltroChange(value: string) {
    if (value) {
      this.getRegrasDeCalculoStore.getLocalExecucaoByFontePagadora()
    }
  }

  @Watch('showModal')
  onShowModalChange(value: boolean) {
    if (!value) {
      this.getRegrasDeCalculoStore.clearRegraGestao()
    }
  }
}
